import merge from 'lodash/merge';

import type { Report } from 'app-components/flux/generated-reports/generatedReportsTypes';
import type { TaxInputProps } from './taxesTypes';

export const mapTaxReportToTaxInput = (taxReport: Report): TaxInputProps => {
  const valueColumn = taxReport.columns?.find(
    (column) => 'id' in column.headerValue && column.headerValue.id === 'Amount',
  );
  if (!valueColumn) {
    return {};
  }

  const taxInputProps = taxReport.rows.reduce((taxInput: TaxInputProps, row) => {
    if (row.entityType === 'TAX_LINE_ITEM') {
      const valueString = row.cellData.find((cell) => cell.columnId === valueColumn.id)?.value;
      const valueNumber = Number(valueString);
      const value = isNaN(valueNumber) ? undefined : valueNumber;
      if (value) {
        switch (row.entityId) {
          case 'USA_327':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { royalties: (taxInput.scheduleE?.royalties || 0) + value },
            });
            break;
          case 'USA_502':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_329':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_335':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_823':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { rentalPropertyMileage: (taxInput.scheduleE?.rentalPropertyMileage || 0) + value },
            });
            break;
          case 'USA_326':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { rents: (taxInput.scheduleE?.rents || 0) + value },
            });
            break;
          case 'USA_331':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_334':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_339':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_338':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_332':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_336':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_341':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: {
                unspecifiedRentalPropertyExpense: (taxInput.scheduleE?.unspecifiedRentalPropertyExpense || 0) + value,
              },
            });
            break;
          case 'USA_887':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_333':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: {
                expenses: (taxInput.scheduleE?.expenses || 0) + value,
              },
            });
            break;
          case 'USA_337':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_328':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_330':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleE: { expenses: (taxInput.scheduleE?.expenses || 0) + value },
            });
            break;
          case 'USA_367':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_357':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_350':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_355':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_372':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { supplementalPayments: (taxInput.scheduleF?.supplementalPayments || 0) + value },
            });
            break;
          case 'USA_349':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_543':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_359':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_368':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { sales: (taxInput.scheduleF?.sales || 0) + value },
            });
            break;
          case 'USA_377':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: (taxInput.scheduleF?.othIncome || 0) + value },
            });
            break;
          case 'USA_371':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_361':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_360':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_353':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_345':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_347':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_351':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_362':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_352':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_378':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_356':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_365':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_346':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_366':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_364':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_369':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: (taxInput.scheduleF?.othIncome || 0) + value },
            });
            break;
          case 'USA_370':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: (taxInput.scheduleF?.othIncome || 0) + value },
            });
            break;
          case 'USA_363':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_358':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_348':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_375':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { othIncome: (taxInput.scheduleF?.othIncome || 0) + value },
            });
            break;
          case 'USA_344':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleF: { expenses: (taxInput.scheduleF?.expenses || 0) + value },
            });
            break;
          case 'USA_303':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: { revenueSelf: (taxInput.businessIncome?.revenueSelf || 0) + value },
            });
            break;
          case 'USA_302':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_820':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                deductibleBusinessMileageSelf: (taxInput.businessIncome?.deductibleBusinessMileageSelf || 0) + value,
              },
            });
            break;
          case 'USA_495':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: { costOfGoodsSelf: (taxInput.businessIncome?.costOfGoodsSelf || 0) + value },
            });
            break;
          case 'USA_299':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_494':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: { costOfGoodsSelf: (taxInput.businessIncome?.costOfGoodsSelf || 0) + value },
            });
            break;
          case 'USA_496':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: { costOfGoodsSelf: (taxInput.businessIncome?.costOfGoodsSelf || 0) + value },
            });
            break;
          case 'USA_306':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_310':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_318':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_301':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_293':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: { revenueSelf: (taxInput.businessIncome?.revenueSelf || 0) + value },
            });
            break;
          case 'USA_685':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_315':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_304':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_312':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_313':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_316':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_297':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_311':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_308':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_307':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_317':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_309':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_314':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_300':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_294':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                mealsAndEntertainmentSelf: (taxInput.businessIncome?.mealsAndEntertainmentSelf || 0) + value,
              },
            });
            break;
          case 'USA_298':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_305':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_493':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: { costOfGoodsSelf: (taxInput.businessIncome?.costOfGoodsSelf || 0) + value },
            });
            break;
          case 'USA_321':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: { shortTermGains: (taxInput.capitalGains?.shortTermGains || 0) + value },
            });
            break;
          case 'USA_810':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: { shortTermGains: (taxInput.capitalGains?.shortTermGains || 0) + value },
            });
            break;
          case 'USA_323':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: { longTermGains: (taxInput.capitalGains?.longTermGains || 0) + value },
            });
            break;
          case 'USA_283':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                allowableMortgageAndOtherDeductibleInterest:
                  (taxInput.scheduleADeductions?.allowableMortgageAndOtherDeductibleInterest || 0) + value,
              },
            });
            break;
          case 'USA_280':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                charitableContributions: (taxInput.scheduleADeductions?.charitableContributions || 0) + value,
              },
            });
            break;
          case 'USA_486':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: { miscDeductions: (taxInput.scheduleADeductions?.miscDeductions || 0) + value },
            });
            break;
          case 'USA_272':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: { miscDeductions: (taxInput.scheduleADeductions?.miscDeductions || 0) + value },
            });
            break;
          case 'USA_484':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: (taxInput.scheduleADeductions?.medicalAndDental || 0) + value,
              },
            });
            break;
          case 'USA_485':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                charitableContributions: (taxInput.scheduleADeductions?.charitableContributions || 0) + value,
              },
            });
            break;
          case 'USA_271':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: { miscDeductions: (taxInput.scheduleADeductions?.miscDeductions || 0) + value },
            });
            break;
          case 'USA_274':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: (taxInput.scheduleADeductions?.medicalAndDental || 0) + value,
              },
            });
            break;
          case 'USA_273':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: (taxInput.scheduleADeductions?.medicalAndDental || 0) + value,
              },
            });
            break;
          case 'USA_535':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_821':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: { miscDeductions: (taxInput.scheduleADeductions?.miscDeductions || 0) + value },
            });
            break;
          case 'USA_523':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                miscDeductionsNoLimit: (taxInput.scheduleADeductions?.miscDeductionsNoLimit || 0) + value,
              },
            });
            break;
          case 'USA_284':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: { miscDeductions: (taxInput.scheduleADeductions?.miscDeductions || 0) + value },
            });
            break;
          case 'USA_822':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                medicalAndDental: (taxInput.scheduleADeductions?.medicalAndDental || 0) + value,
              },
            });
            break;
          case 'USA_545':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                allowableMortgageAndOtherDeductibleInterest:
                  (taxInput.scheduleADeductions?.allowableMortgageAndOtherDeductibleInterest || 0) + value,
              },
            });
            break;
          case 'USA_522':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                estimatedTaxesPaidToDatePlusProjected:
                  (taxInput.stateAndLocalIncomeTax?.estimatedTaxesPaidToDatePlusProjected || 0) + value,
              },
            });
            break;
          case 'USA_282':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: { miscDeductions: (taxInput.scheduleADeductions?.miscDeductions || 0) + value },
            });
            break;
          case 'USA_277':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_276':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_281':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: { miscDeductions: (taxInput.scheduleADeductions?.miscDeductions || 0) + value },
            });
            break;
          case 'USA_490':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: {
                taxableInterest: (taxInput.divInterest?.taxableInterest || 0) + value,
              },
            });
            break;
          case 'USA_287':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: { taxableInterest: (taxInput.divInterest?.taxableInterest || 0) + value },
            });
            break;
          case 'USA_286':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: { dividends: (taxInput.divInterest?.dividends || 0) + value },
            });
            break;
          case 'USA_683':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              divInterest: { qualifiedDividends: (taxInput.divInterest?.qualifiedDividends || 0) + value },
            });
            break;
          case 'USA_488':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              capitalGains: { shortTermGains: (taxInput.capitalGains?.shortTermGains || 0) + value },
            });
            break;
          case 'USA_559':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: {
                otherIncomeGainsOrLosses: (taxInput.otherIncome?.otherIncomeGainsOrLosses || 0) + value,
              },
            });
            break;
          case 'USA_556':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_557':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_259':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_562':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_555':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_561':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              scheduleADeductions: {
                realEstateAndOtherTaxes: (taxInput.scheduleADeductions?.realEstateAndOtherTaxes || 0) + value,
              },
            });
            break;
          case 'USA_261':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: { alimonyReceived: (taxInput.otherIncome?.alimonyReceived || 0) + value },
            });
            break;
          case 'USA_262':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              adjustments: { allowableIRADeduction: (taxInput.adjustments?.allowableIRADeduction || 0) + value },
            });
            break;
          case 'USA_481':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              adjustments: { allowableIRADeduction: (taxInput.adjustments?.allowableIRADeduction || 0) + value },
            });
            break;
          case 'USA_519':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: {
                socialSecurityRRAIncome: (taxInput.otherIncome?.socialSecurityRRAIncome || 0) + value,
              },
            });
            break;
          case 'USA_520':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              otherIncome: {
                socialSecurityRRAIncome: (taxInput.otherIncome?.socialSecurityRRAIncome || 0) + value,
              },
            });
            break;
          case 'USA_264':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              adjustments: { alimonyPaid: (taxInput.adjustments?.alimonyPaid || 0) + value },
            });
            break;
          case 'USA_382':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_385':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                unspecifiedBusinessExpensesSelf:
                  (taxInput.businessIncome?.unspecifiedBusinessExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_381':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_384':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_386':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                mealsAndEntertainmentSelf: (taxInput.businessIncome?.mealsAndEntertainmentSelf || 0) + value,
              },
            });
            break;
          case 'USA_824':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                deductibleBusinessMileageSelf: (taxInput.businessIncome?.deductibleBusinessMileageSelf || 0) + value,
              },
            });
            break;
          case 'USA_390':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_389':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_391':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                businessUseOfHomeSelf: (taxInput.businessIncome?.businessUseOfHomeSelf || 0) + value,
              },
            });
            break;
          case 'USA_383':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              businessIncome: {
                otherAllowableExpensesSelf: (taxInput.businessIncome?.otherAllowableExpensesSelf || 0) + value,
              },
            });
            break;
          case 'USA_461':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              withholdingsAndSummary: {
                withholdingsSelf: (taxInput.withholdingsAndSummary?.withholdingsSelf || 0) + value,
              },
            });
            break;
          case 'USA_507':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              withholdingsAndSummary: {
                withholdingsSpouse: (taxInput.withholdingsAndSummary?.withholdingsSpouse || 0) + value,
              },
            });
            break;
          case 'USA_506':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              wages: {
                spouseWages: (taxInput.wages?.spouseWages || 0) + value,
              },
            });
            break;
          case 'USA_460':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              wages: { selfWages: (taxInput.wages?.selfWages || 0) + value },
            });
            break;
          case 'USA_464':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSelf: (taxInput.stateAndLocalIncomeTax?.withholdingsSelf || 0) + value,
              },
            });
            break;
          case 'USA_511':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSpouse: (taxInput.stateAndLocalIncomeTax?.withholdingsSpouse || 0) + value,
              },
            });
            break;
          case 'USA_509':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSpouse: (taxInput.stateAndLocalIncomeTax?.withholdingsSpouse || 0) + value,
              },
            });
            break;
          case 'USA_462':
            merge<TaxInputProps, TaxInputProps>(taxInput, {
              stateAndLocalIncomeTax: {
                withholdingsSelf: (taxInput.stateAndLocalIncomeTax?.withholdingsSelf || 0) + value,
              },
            });
            break;
        }
      }
    }
    return taxInput;
  }, {});

  return taxInputProps;
};
